import React, { useState, useRef, useEffect } from 'react'
import { dashboardAts, postFlashIcon, smartScreeningIcon, teamworkIcon, FileCheckIcon, EmpOnboardingIcon, PerformanceShineIcon, EmpPulseIcon, AlumiPortalIcon, EsopEmpIcon, LearningExpIcon, UserCompensationIcon, payrollSolIcon, empChatIcon, G2Leader2025badgeImg, AnalyticsImg } from '../assets/images'
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
// import other icons as needed

gsap.registerPlugin(ScrollTrigger);

const tickSvg = (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
    <path d="M11 22.8896C17.0751 22.8896 22 17.9648 22 11.8896C22 5.81452 17.0751 0.889648 11 0.889648C4.92487 0.889648 0 5.81452 0 11.8896C0 17.9648 4.92487 22.8896 11 22.8896Z" fill="#DCFCE7" />
    <path d="M8.82349 16.4679L6.24418 13.9486C6.18839 13.8943 6.14404 13.8295 6.11376 13.7578C6.08347 13.6861 6.06787 13.6091 6.06787 13.5313C6.06787 13.4535 6.08347 13.3765 6.11376 13.3048C6.14404 13.2332 6.18839 13.1683 6.24418 13.1141L7.09952 12.2796C7.21423 12.1685 7.36767 12.1063 7.52739 12.1063C7.6871 12.1063 7.84055 12.1685 7.95525 12.2796L9.4907 13.7805L13.797 7.23363C13.8859 7.10152 14.0226 7.00914 14.1783 6.97601C14.3341 6.94288 14.4966 6.97161 14.6315 7.05611L15.6496 7.69563C15.7161 7.73652 15.7737 7.79034 15.819 7.85391C15.8643 7.91748 15.8963 7.9895 15.9133 8.0657C15.9302 8.1419 15.9317 8.22073 15.9176 8.2975C15.9035 8.37428 15.8742 8.44745 15.8312 8.51266L10.7322 16.2673C10.63 16.4191 10.4958 16.5466 10.339 16.6409C10.1822 16.7352 10.0066 16.794 9.82467 16.8132C9.6427 16.8323 9.45875 16.8113 9.28578 16.7516C9.1128 16.692 8.955 16.5952 8.82349 16.4679Z" fill="#17A34A" />
  </svg>
);
const chevronDownSvg = (
  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="20" viewBox="0 0 19 20" fill="none">
    <path d="M16.0517 0.889648H2.94828C1.32279 0.889648 0 2.21244 0 3.83792V16.9414C0 18.5669 1.32279 19.8896 2.94828 19.8896H16.0517C17.6772 19.8896 19 18.5669 19 16.9414V3.83792C19 2.21244 17.6772 0.889648 16.0517 0.889648Z" fill="#C18CFF" />
    <path d="M15.8197 6.88187L9.49991 13.2023L3.18012 6.88252C3.05236 6.75477 2.84467 6.75477 2.71691 6.88252C2.58915 7.01028 2.58915 7.21797 2.71691 7.34573L9.26864 13.8975C9.33219 13.961 9.41605 13.9931 9.49991 13.9931C9.58378 13.9931 9.66764 13.961 9.73184 13.8975L16.2836 7.34573C16.4113 7.21797 16.4113 7.01028 16.2836 6.88252C16.1558 6.75477 15.9481 6.75411 15.8197 6.88187Z" fill="#ECF0F1" />
  </svg>
);

const upcomingModules = [
  {
    icon: FileCheckIcon,
    badge: 'Coming Soon',
    title: 'HR Compliance Management',
    subtitle: 'Compliance Without the Complications',
    desc: 'Never miss a PF deadline or worry about PoSH audits again. Symplora keeps your records updated, your team compliant, and your HR safe from surprises.',
    features: [
      { text: 'Auto-Alerts', desc: 'Get notified of rule changes and filing dates' },
      { text: 'Audit-Ready Records', desc: 'Stay organized and ready for inspection' },
      { text: 'Built-In Risk Management', desc: 'Spot compliance gaps before they become fines' },
    ],
    learnMore: '#'
  },
  {
    icon: EmpOnboardingIcon,
    badge: 'Coming Soon',
    title: 'Employee Onboarding & Core HR',
    subtitle: 'Make Every New Hire Feel at Home',
    desc: 'From documentation to day-one readiness, Symplora makes onboarding personal, easy, and efficient—while keeping all employee data in one place.',
    features: [
      { text: 'Auto-Alerts', desc: 'Get notified of rule changes and filing dates' },
      { text: 'Audit-Ready Records', desc: 'Stay organized and ready for inspection' },
      { text: 'Built-In Risk Management', desc: 'Spot compliance gaps before they become fines' },
    ],
    learnMore: '#'
  },
  {
    icon: PerformanceShineIcon,
    badge: 'Coming Soon',
    title: 'Performance & Talent Management',
    subtitle: 'Real Feedback, Real Results, Real Growth',
    desc: "Performance reviews shouldn't feel like punishment. With Symplora, performance is a continuous, clear, and growth-focused process.",
    features: [
      { text: 'Auto-Alerts', desc: 'Get notified of rule changes and filing dates' },
      { text: 'Audit-Ready Records', desc: 'Stay organized and ready for inspection' },
      { text: 'Built-In Risk Management', desc: 'Spot compliance gaps before they become fines' },
    ],
    learnMore: '#'
  },
  {
    icon: EmpPulseIcon,
    badge: 'Coming Soon',
    title: 'Employee Pulse & Sentiment Analysis',
    subtitle: "Stay in Tune with Your Team's True Feelings",
    desc: "Employee morale isn't a mystery anymore. Capture real-time feedback and emotional insights to stay ahead of burnout and disengagement.",
    features: [
      { text: 'Auto-Alerts', desc: 'Get notified of rule changes and filing dates' },
      { text: 'Audit-Ready Records', desc: 'Stay organized and ready for inspection' },
      { text: 'Built-In Risk Management', desc: 'Spot compliance gaps before they become fines' },
    ],
    learnMore: '#'
  },
  {
    icon: AlumiPortalIcon,
    badge: 'Coming Soon',
    title: 'Company Alumni Portal',
    subtitle: "Keep the Talent Close Even After They've Moved On",
    desc: 'Your best hires may come back—if you stay connected. Build an alumni network that brings referrals, rehiring, and brand advocacy.',
    features: [
      { text: 'Auto-Alerts', desc: 'Get notified of rule changes and filing dates' },
      { text: 'Audit-Ready Records', desc: 'Stay organized and ready for inspection' },
      { text: 'Built-In Risk Management', desc: 'Spot compliance gaps before they become fines' },
    ],
    learnMore: '#'
  },
  {
    icon: EsopEmpIcon,
    badge: 'Coming Soon',
    title: 'ESOP Management & Digital Signature',
    subtitle: 'Simplify Stock Options, Secure Every Signature',
    desc: 'No more manual grant letters or signing delays. Symplora makes ESOPs and document signing seamless, trackable, and compliant.',
    features: [
      { text: 'Auto-Alerts', desc: 'Get notified of rule changes and filing dates' },
      { text: 'Audit-Ready Records', desc: 'Stay organized and ready for inspection' },
      { text: 'Built-In Risk Management', desc: 'Spot compliance gaps before they become fines' },
    ],
    learnMore: '#'
  },
  {
    icon: LearningExpIcon,
    badge: 'Coming Soon',
    title: 'Learning Experience Platform',
    subtitle: 'Learning That Grows with Your Team',
    desc: 'From onboarding to leadership training, Symplora helps your team grow with interactive learning paths that actually get completed.',
    features: [
      { text: 'Auto-Alerts', desc: 'Get notified of rule changes and filing dates' },
      { text: 'Audit-Ready Records', desc: 'Stay organized and ready for inspection' },
      { text: 'Built-In Risk Management', desc: 'Spot compliance gaps before they become fines' },
    ],
    learnMore: '#'
  },
  {
    icon: UserCompensationIcon,
    badge: 'Coming Soon',
    title: 'Compensation Management',
    subtitle: 'Compensation That Makes Sense (and Cents)',
    desc: 'Plan raises, bonuses, and benefits without spreadsheets. Symplora makes compensation transparent, compliant, and aligned with budgets.',
    features: [
      { text: 'Auto-Alerts', desc: 'Get notified of rule changes and filing dates' },
      { text: 'Audit-Ready Records', desc: 'Stay organized and ready for inspection' },
      { text: 'Built-In Risk Management', desc: 'Spot compliance gaps before they become fines' },
    ],
    learnMore: '#'
  },
  {
    icon: payrollSolIcon,
    badge: 'Coming Soon',
    title: 'Payroll Solutions',
    subtitle: 'Payroll That Works Everywhere You Do',
    desc: 'Global teams? Local compliance? No problem. Symplora ensures timely, accurate payouts worldwide.',
    features: [
      { text: 'Auto-Alerts', desc: 'Get notified of rule changes and filing dates' },
      { text: 'Audit-Ready Records', desc: 'Stay organized and ready for inspection' },
      { text: 'Built-In Risk Management', desc: 'Spot compliance gaps before they become fines' },
    ],
    learnMore: '#'
  },
  {
    icon: empChatIcon,
    badge: 'Coming Soon',
    title: 'Employee Chat & Asset Management',
    subtitle: 'One Platform for Chats and Checklists',
    desc: 'No more switching tabs or losing track of hardware. Communicate and manage assets in one place.',
    features: [
      { text: 'Auto-Alerts', desc: 'Get notified of rule changes and filing dates' },
      { text: 'Audit-Ready Records', desc: 'Stay organized and ready for inspection' },
      { text: 'Built-In Risk Management', desc: 'Spot compliance gaps before they become fines' },
    ],
    learnMore: '#'
  }
];

const ATSFeatures = () => {
  const [openIdx, setOpenIdx] = useState(null);
  const heroTitleRef = useRef(null);
  const heroSubheadingRef = useRef(null);
  const heroButtonsRef = useRef(null);
  const atsLeftRef = useRef(null);
  const atsRightRef = useRef(null);
  const atsFeaturesRef = useRef(null);
  const exploreTitleRef = useRef(null);
  const exploreGridRef = useRef(null);
  const exploreWideCardRef = useRef(null);
  const decisionsHeadingRef = useRef(null);
  const decisionsSubheadingRef = useRef(null);
  const decisionsCardsRef = useRef(null);
  const ctaTitleRef = useRef(null);
  const ctaButtonsRef = useRef(null);

  useEffect(() => {
    // Hero section animations
    const heroElements = [
      heroTitleRef.current,
      heroSubheadingRef.current,
      heroButtonsRef.current
    ];

    gsap.fromTo(heroElements,
      {
        y: 50,
        opacity: 0
      },
      {
        y: 0,
        opacity: 1,
        duration: 0.8,
        stagger: 0.2,
        ease: "power2.out"
      }
    );

    // ATS section animations
    // Left content animation
    const atsLeftElements = atsLeftRef.current?.querySelectorAll('*');
    if (atsLeftElements) {
      gsap.fromTo(atsLeftElements,
        {
          x: -50,
          opacity: 0
        },
        {
          x: 0,
          opacity: 1,
          duration: 0.8,
          stagger: 0.15,
          ease: "power2.out",
          scrollTrigger: {
            trigger: atsLeftRef.current,
            start: "top 80%",
            toggleActions: "play none none none"
          }
        }
      );
    }

    // Right image animation
    if (atsRightRef.current) {
      gsap.fromTo(atsRightRef.current,
        {
          x: 50,
          opacity: 0,
          scale: 0.95
        },
        {
          x: 0,
          opacity: 1,
          scale: 1,
          duration: 1,
          ease: "power2.out",
          scrollTrigger: {
            trigger: atsRightRef.current,
            start: "top 80%",
            toggleActions: "play none none none"
          }
        }
      );
    }

    // Features row animation
    const featureCards = atsFeaturesRef.current?.querySelectorAll('.ats-feature-card');
    if (featureCards) {
      gsap.fromTo(featureCards,
        {
          y: 30,
          opacity: 0
        },
        {
          y: 0,
          opacity: 1,
          duration: 0.6,
          stagger: 0.2,
          ease: "power2.out",
          scrollTrigger: {
            trigger: atsFeaturesRef.current,
            start: "top 85%",
            toggleActions: "play none none none"
          }
        }
      );
    }

    // Explore section animations
    // Title animation
    if (exploreTitleRef.current) {
      gsap.fromTo(exploreTitleRef.current,
        {
          y: 30,
          opacity: 0
        },
        {
          y: 0,
          opacity: 1,
          duration: 0.8,
          ease: "power2.out",
          scrollTrigger: {
            trigger: exploreTitleRef.current,
            start: "top 85%",
            toggleActions: "play none none none"
          }
        }
      );
    }

    // Regular cards animation
    const exploreCards = exploreGridRef.current?.querySelectorAll('.explore-card:not(.explore-card--wide)');
    if (exploreCards) {
      gsap.fromTo(exploreCards,
        {
          y: 50,
          opacity: 0,
          scale: 0.95
        },
        {
          y: 0,
          opacity: 1,
          scale: 1,
          duration: 0.6,
          stagger: 0.1,
          ease: "power2.out",
          scrollTrigger: {
            trigger: exploreGridRef.current,
            start: "top 80%",
            toggleActions: "play none none none"
          }
        }
      );
    }

    // Wide card animation
    if (exploreWideCardRef.current) {
      const wideCardElements = exploreWideCardRef.current.querySelectorAll('*');
      gsap.fromTo(wideCardElements,
        {
          y: 30,
          opacity: 0
        },
        {
          y: 0,
          opacity: 1,
          duration: 0.8,
          stagger: 0.15,
          ease: "power2.out",
          scrollTrigger: {
            trigger: exploreWideCardRef.current,
            start: "top 85%",
            toggleActions: "play none none none"
          }
        }
      );
    }

    // Decisions section animations
    // Heading and subheading animation
    if (decisionsHeadingRef.current && decisionsSubheadingRef.current) {
      gsap.fromTo([decisionsHeadingRef.current, decisionsSubheadingRef.current],
        {
          y: 30,
          opacity: 0
        },
        {
          y: 0,
          opacity: 1,
          duration: 0.8,
          stagger: 0.2,
          ease: "power2.out",
          scrollTrigger: {
            trigger: decisionsHeadingRef.current,
            start: "top 85%",
            toggleActions: "play none none none"
          }
        }
      );
    }

    // Cards animation
    const cards = decisionsCardsRef.current?.querySelectorAll('.card');
    if (cards) {
      gsap.fromTo(cards,
        {
          y: 50,
          opacity: 0,
          scale: 0.9
        },
        {
          y: 0,
          opacity: 1,
          scale: 1,
          duration: 0.6,
          stagger: 0.15,
          ease: "power2.out",
          scrollTrigger: {
            trigger: decisionsCardsRef.current,
            start: "top 80%",
            toggleActions: "play none none none"
          }
        }
      );

      // Animate the numbers inside cards
      cards.forEach(card => {
        const number = card.querySelector('.discount');
        if (number) {
          gsap.fromTo(number,
            {
              scale: 0.5,
              opacity: 0
            },
            {
              scale: 1,
              opacity: 1,
              duration: 0.8,
              ease: "back.out(1.7)",
              scrollTrigger: {
                trigger: card,
                start: "top 85%",
                toggleActions: "play none none none"
              }
            }
          );
        }
      });
    }

    // CTA section animations
    // Title animation
    if (ctaTitleRef.current) {
      gsap.fromTo(ctaTitleRef.current,
        {
          y: 40,
          opacity: 0,
          scale: 0.95
        },
        {
          y: 0,
          opacity: 1,
          scale: 1,
          duration: 1,
          ease: "power2.out",
          scrollTrigger: {
            trigger: ctaTitleRef.current,
            start: "top 85%",
            toggleActions: "play none none none"
          }
        }
      );
    }

    // Buttons animation
    const buttons = ctaButtonsRef.current?.querySelectorAll('.btn');
    if (buttons) {
      gsap.fromTo(buttons,
        {
          y: 30,
          opacity: 0,
          scale: 0.9
        },
        {
          y: 0,
          opacity: 1,
          scale: 1,
          duration: 0.8,
          stagger: 0.2,
          ease: "back.out(1.7)",
          scrollTrigger: {
            trigger: ctaButtonsRef.current,
            start: "top 85%",
            toggleActions: "play none none none"
          }
        }
      );
    }
  }, []);

  return (
    <>
      {/* Modules Hero Section (keep this at the top) */}
      <section className="ats-hero-section">
        <div className="container">
          <div className="ats-hero-content">
            <h1 ref={heroTitleRef} className="ats-hero-title text-display-1">
              Simplify, Streamline, and Succeed with <br />
              <span className="primary-text-color">Symplora's Next-Gen Modules.</span>
            </h1>
            <p ref={heroSubheadingRef} className="ats-hero-subheading text-heading-2 fw-500">
              Empowering HR teams with tools that automate tasks, eliminate inefficiencies, and drive productivity.
            </p>
          </div>
          <div ref={heroButtonsRef} className="button-wrapper">
            <button className="btn btn--primary btn--regular">Explore all modules</button>
            <button className="btn btn--white btn--regular">Schedule a demo</button>
          </div>
        </div>
      </section>

      {/* ATS Hero Section (purple background) */}
      <section className="ats-ats-section">
        <div className="container">
          <div className="ats-main">
            <div ref={atsLeftRef} className="ats-main-left">
              <span className="ats-live-badge">Live</span>
              <h1 className="ats-title">Applicant Tracking System</h1>
              <h2 className="ats-subtitle">Hiring Just Got a Whole Lot Easier</h2>
              <p className="ats-desc">
                Simplify sourcing, screening, and hiring—so you can focus on what truly matters: finding the right fit, faster.
              </p>
              <button className="btn btn--outlined btn-white btn--regular">Learn More</button>
            </div>
            <div ref={atsRightRef} className="ats-main-right">
              <img src={dashboardAts} alt="ATS Dashboard" />
            </div>
          </div>
          <div ref={atsFeaturesRef} className="ats-features-row">
            <div className="ats-feature-card">
              <div className="ats-feature-icon"><img src={postFlashIcon} alt="Post Jobs" /></div>
              <div className="ats-feature-card-content">
                <div className="ats-feature-title text-heading-2 fw-700">Post Jobs in a Flash</div>
                <div className="ats-feature-desc text-body fw-700">Maximize job visibility across platforms in a click</div>
              </div>
            </div>
            <div className="ats-feature-card">
              <div className="ats-feature-icon"><img src={smartScreeningIcon} alt="Smart Screening" /></div>
              <div className="ats-feature-card-content">
                <div className="ats-feature-title text-heading-2 fw-700">Smart Screening with AI</div>
                <div className="ats-feature-desc text-body fw-700">Let algorithms bring top candidates forward</div>
              </div>
            </div>
            <div className="ats-feature-card">
              <div className="ats-feature-icon"><img src={teamworkIcon} alt="Teamwork" /></div>
              <div className="ats-feature-card-content">
                <div className="ats-feature-title text-heading-2 fw-700">Teamwork Made Simple</div>
                <div className="ats-feature-desc text-body fw-700">Collaborate, share notes, and make hiring decisions faster</div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ATS Hero Section (purple background) */}

      {/* More to Explore Section */}
      <section className="explore-section">
        <div className="container">
          <h2 ref={exploreTitleRef} className="explore-title text-display-1">More to Explore: Upcoming Modules on the Way!</h2>
          <div ref={exploreGridRef} className="explore-grid">
            {upcomingModules.map((mod, idx) => (
              <div className={`explore-card${openIdx ? ' explore-card--open' : ''}`} key={mod.title} >
                <div className="explore-card-header">
                  <img className="explore-card-icon" src={mod.icon} alt="icon" />
                  {mod.badge && <span className="explore-badge">{mod.badge}</span>}
                </div>
                <div className="explore-card-title text-subheading fw-700">{mod.title}</div>
                <div className="explore-card-subtitle text-body fw-700">{mod.subtitle}</div>
                <div className="explore-card-desc text-body fw-400">{mod.desc}</div>
                {mod.features && (
                  <button
                    className="explore-chevron-btn"
                    onClick={() => setOpenIdx(!openIdx ? true : false)}
                    aria-label={openIdx ? 'Collapse details' : 'Expand details'}
                    style={{
                      transform: openIdx ? 'rotate(180deg)' : 'rotate(0deg)',
                      transition: 'transform 0.2s ease-in-out'
                    }}
                  >
                    {chevronDownSvg}
                  </button>
                )}
                {mod.features && openIdx && (
                  <div className="explore-card-dropdown">
                    <ul className="explore-feature-list">
                      {mod.features.map((f, i) => (
                        <li className="explore-feature-item flex align-start" key={f.text}>
                          <span className="explore-feature-tick">{tickSvg}</span>
                          <div>
                            <span className="explore-feature-main text-body fw-700">{f.text}</span>
                            <span className="explore-feature-desc text-body-1">{f.desc}</span>
                          </div>
                        </li>
                      ))}
                    </ul>
                    <a href={mod.learnMore} className="explore-learn-btn">Learn More &rarr;</a>
                  </div>
                )}
              </div>
            ))}
            {/* Special cards in the last row */}
            <div ref={exploreWideCardRef} className="explore-card explore-card--wide">
              <div className="g2-leader-badge">
                <h3 className="g2-leader-badge-title text-heading-1 fw-700 mb-3 pb-3">The best HRMS platform</h3>
                <img src={G2Leader2025badgeImg} alt="G2 Leader 2025" />
              </div>
              <div className="analytics-info">
                <h3 className="analytics-title text-heading-1 fw-700 mb-3">Analytics</h3>
                <p className="analytics-desc text-body mb-4">Analyze your events' engagement data with our powerful reports built into the dashboard.</p>
                <div className="analytics-img">
                  <img src={AnalyticsImg} alt="Analytics" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/*------------Decisions-section------------*/}
      <section className="decisions-section with-four-cards features-ats-section">
        <div className="container">
          <h3 ref={decisionsHeadingRef} className="primary-text-color text-center fw-700 text-heading heading">Trusted Impact, Tangible Results</h3>
          <p ref={decisionsSubheadingRef} className="sub-heading text-subheading text-center">Your time, your team, and your sanity—recovered. With Symplora, HR moves from reactive to remarkable.</p>
          <div ref={decisionsCardsRef} className="cards-wrapper flex">
            <div className="card" >
              <div className="flex align-center justify-center">
                <span className="fw-700 discount">50%</span>
              </div>
              <div className="card-content text-body-1 text-center fw-500"><p>faster hiring</p></div>
            </div>
            <div className="card">
              <div className="flex align-center justify-center">
                <span className="fw-700 discount">40%</span>
              </div>
              <div className="card-content text-body-1 text-center fw-500"><p>fewer payroll errors</p></div>
            </div>
            <div className="card" >
              <p className="fw-700 discount text-center">20+</p>
              <div className="card-content text-body-1 text-center fw-500"><p>hours saved per onboarding</p></div>
            </div>
            <div className="card">
              <p className="fw-700 discount text-center">30%</p>
              <div className="card-content text-body-1 text-center fw-500"><p>increase in team engagement</p></div>
            </div>
          </div>
        </div>
      </section>
      {/*------------Decisions-section------------*/}

      {/*------------CTA section------------*/}
      <section className="cta-section">
        <div className="container text-center">
          <h2 ref={ctaTitleRef} className="cta-title text-display-1">Ready to Transform Your HR Processes?</h2>
          <div ref={ctaButtonsRef} className="btn-wrapper">
            <button className="btn btn--primary btn--regular">Schedule a Demo</button>
            <button className="btn btn--outlined btn-white btn--regular">Explore All Modules</button>
          </div>
        </div>
      </section>
      {/*------------CTA section------------*/}
    </>
  )
}

export default ATSFeatures